import script from "./ViewModeSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewModeSwitch.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__